'use strict';

exports.__esModule = true;
exports['default'] = jssVendorPrefixerIE10;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _isIE = require('./isIE');

var _isIE2 = _interopRequireDefault(_isIE);

var iePropMap = {
  'flex-grow': '-ms-flex-positive',
  'flex-shrink': '-ms-flex-negative',
  'flex-basis': '-ms-flex-preferred-size',
  'align-items': '-ms-flex-align',
  'flex-wrap': '-ms-flex-wrap',
  'order': '-ms-flex-order',
  'justify-content': '-ms-flex-pack',
  'align-self': '-ms-flex-item-align',
  'align-content': '-ms-flex-line-pack'
};

var ieValueMap = {
  'flex': '-ms-flexbox',
  'inline-flex': '-ms-inline-flexbox',
  'flex-start': 'start',
  'flex-end': 'end',
  'space-between': 'justify'
};

/**
 * Add vendor prefix to a property name when needed.
 *
 * @param {Rule} rule
 * @api public
 */

function jssVendorPrefixerIE10() {
  return function (rule) {
    if (!_isIE2['default']() || rule.type !== 'regular') return;

    for (var prop in rule.style) {
      var value = rule.style[prop];
      var changeProp = iePropMap[prop];
      var changeValue = ieValueMap[value];

      if (changeValue) {
        rule.style[prop] = changeValue;
      }

      if (changeProp) {
        rule.style[changeProp] = rule.style[prop];
        delete rule.style[prop];
      }
    }
  };
}

module.exports = exports['default'];